// XXX until we can express route dependencies through Flux instead of promises
import { rootGroup } from 'entities/RootGroup';
import ChatActions from 'chat_v2/actions/ChatActions';
import Chats from 'collections/Chats';
import ChatStore from 'chat_v2/stores/ChatStore';
import Group from 'entities/Group';
// @ts-ignore
import GroupStore from 'groups/stores/GroupStore';
// @ts-ignore
import PotentialChatMember from 'entities/PotentialChatMember';
import ChatMember from 'entities/ChatMember';
// @ts-ignore
import RelationshipActions from 'actions/RelationshipActions';
// @ts-ignore
import RelationshipStore from 'stores/RelationshipStore';
// @ts-ignore
import RelatedUserSummary from 'entities/RelatedUserSummary';
import Subscriber from 'entities/Subscriber';
// @ts-ignore
import User from 'entities/User';
// @ts-ignore
import Relationship from 'entities/Relationship';

function promiseGroupChats(group: Group): Promise<Chats | void> {
  // If all chats are loaded for all groups, resolve immediately
  if (ChatStore.areAllChatsLoaded()) {
    return Promise.resolve(ChatStore.getChats({ id: group.getId(), className: group.getName() }));
  }

  // If the first page of chats have been loaded for the requested group
  // resolve with all the chats we have for this group
  if (ChatStore.haveChatsBeenLoadedForGroup(group)) {
    return Promise.resolve(ChatStore.getChats({ id: group.getId(), className: group.getName() }));
  } else {
    const existingChats = ChatStore.getChats({ id: group.getId(), className: group.getName() });
    if (existingChats.length) {
      // refresh
      ChatActions.loadChats(group);
      // but return what we've already got
      return Promise.resolve(existingChats);
    }
    // Otherwise fetch chats for this group
    return ChatActions.promiseLoadChats({ id: group.getId() });
  }
}

export function promiseGroupOrRootChats(
  groupCode: string | null | undefined = null
): Promise<Chats | void> {
  const group = groupCode ? GroupStore.getGroupForCode(groupCode) : rootGroup;

  if (!group) {
    return Promise.resolve();
  }

  return promiseGroupChats(group);
}

export function promiseRelationship(
  withUser: RelatedUserSummary | ChatMember | PotentialChatMember | Subscriber | User | number
): Promise<Relationship> {
  const id: number | string = typeof withUser === 'number' ? withUser : withUser.id;
  const relationship =
    RelationshipStore.getRelationship(id) || RelationshipActions.loadRelationship(id);
  if (relationship) {
    return Promise.resolve(relationship);
  } else {
    return Promise.reject(new Error('promiseRelationship could not resolve'));
  }
}
